import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuth } from "./AuthContext";
import LoginPage from "./LoginPage";
import DashboardPage from "./DashboardPage";
import CreateJobPage from "./CreateJobPage";
import JobsListPage from "./JobsListPage";
import JobDetailsPage from "./JobDetailsPage";
import ProfilePage from "./ProfilePage";
import BillingPage from "./BillingPage";
import PrivateRoute from "./PrivateRoute";
import EmailVerificationPage from "./EmailVerificationPage";
import * as Sentry from "@sentry/react";
import SentryTestPage from "./SentryTestPage";

import Layout from "./Layout";

function App() {
  const { currentUser } = useAuth();

  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Routes>
        <Route
          path="/login"
          element={currentUser ? <Navigate to="/dashboard" /> : <LoginPage />}
        />
        <Route path="/verify-email" element={<EmailVerificationPage />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout title="API Key Management">
                <DashboardPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/create-job"
          element={
            <PrivateRoute>
              <Layout title="Create Job">
                <CreateJobPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/jobs"
          element={
            <PrivateRoute>
              <Layout title="Jobs List">
                <JobsListPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/jobs/:jobId"
          element={
            <PrivateRoute>
              <Layout title="Job Details">
                <JobDetailsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Layout title="Profile">
                <ProfilePage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <PrivateRoute>
              <Layout title="Billing">
                <BillingPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/sentry-test"
          element={
            <PrivateRoute>
              <Layout title="Sentry Test">
                <SentryTestPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="*"
          element={<Navigate to={currentUser ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </Sentry.ErrorBoundary>
  );
}

export default App;
